/**
 * Custom Announcement Bar section
 * ---------------------------------------------------------------------------
 * Extracted from sections/custom-announcement-bar.liquid, where it was inline <script>.
 * Inline scripts are parser-blocking, uncacheable, and re-sent on every page
 * view. This asset is deferred and cached, and initialises every instance on
 * the page instead of binding to a single section id.
 *
 * Initialisation is idempotent: an already-wired element is skipped.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="custom-announcement-bar"]';

  function initSection(container) {
    if (!container || container.dataset.customannouncementbarInit === 'true') return;
    container.dataset.customannouncementbarInit = 'true';

    var sectionId = container.dataset.sectionId;
    const items = container.querySelectorAll('.custom-announcement-bar__item');
    if (items.length <= 1) return;

    const toggleBtn = container.querySelector('[data-action="toggle-play"]');
    const iconPause = container.querySelector('.custom-announcement-bar__icon-pause');
    const iconPlay = container.querySelector('.custom-announcement-bar__icon-play');
    const shouldAutoplay = container.getAttribute('data-autoplay') === 'true';
    const speed = parseInt(container.getAttribute('data-speed'), 10) || 5000;
    const pauseOnHover = container.getAttribute('data-pause-hover') === 'true';

    let currentIndex = 0;
    let timer = null;
    let isPaused = !shouldAutoplay;

    function showSlide(index) {
      items.forEach((item, i) => {
        if (i === index) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
      currentIndex = index;
    }

    function nextSlide() {
      let nextIndex = (currentIndex + 1) % items.length;
      showSlide(nextIndex);
    }

    function startTimer() {
      stopTimer();
      if (!isPaused && shouldAutoplay) {
        timer = setInterval(nextSlide, speed);
      }
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function setPauseState(paused) {
      isPaused = paused;
      if (isPaused) {
        stopTimer();
        if (iconPause && iconPlay) {
          iconPause.style.display = 'none';
          iconPlay.style.display = 'inline-flex';
        }
        if (toggleBtn) {
          toggleBtn.setAttribute('aria-label', 'Play announcement rotation');
          toggleBtn.setAttribute('title', 'Play');
        }
      } else {
        startTimer();
        if (iconPause && iconPlay) {
          iconPause.style.display = 'inline-flex';
          iconPlay.style.display = 'none';
        }
        if (toggleBtn) {
          toggleBtn.setAttribute('aria-label', 'Pause announcement rotation');
          toggleBtn.setAttribute('title', 'Pause');
        }
      }
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        setPauseState(!isPaused);
      });
    }

    if (pauseOnHover) {
      container.addEventListener('mouseenter', function () {
        if (!isPaused) stopTimer();
      });
      container.addEventListener('mouseleave', function () {
        if (!isPaused) startTimer();
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopTimer();
      } else if (!isPaused) {
        startTimer();
      }
    });

    // Start autoplay if enabled
    if (shouldAutoplay) {
      startTimer();
    }

    // Shopify Editor Event Listeners
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target && container.contains(e.target)) {
        const selectedIndex = Array.from(items).indexOf(e.target);
        if (selectedIndex !== -1) {
          stopTimer();
          showSlide(selectedIndex);
        }
      }
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      if (e.target && container.contains(e.target) && !isPaused) {
        startTimer();
      }
    });
  }

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
